<template>
    <div class="compact-gallery double">
        <div ref="gallery" class="compact-gallery-collection" :class="{
            'multiple-images': images.length > 1,
        }" v-if="images.length > 0" @scroll="updateGalleryState">
            <img v-once v-for="(image, index) in images" :key="image.id" width="50%" height="100%"
                :loading="index >= 2 ? 'lazy' : 'eager'" decode="async" fetchpriority="auto" :src="imageUrl(image)"
                onerror="this.onerror=null;this.src='/img/no-image.jpg'"
                @click.prevent="$emit('image-clicked', currentPhotoIndex)" />
        </div>
        <img v-else v-once width="100%" height="100%" loading="lazy" src="/img/no-image.webp" />

        <!-- Controls -->
        <a href="#" class="compact-gallery-collection__next gallery-btn over-desktop-only"
            :class="{ 'active': galleryActive }" v-if="images.length > 1" @click.prevent="nextPhoto">
            <img src="/img/icons/gallery-arrow.svg" alt="arrow right" />
        </a>
        <a href="#" class="compact-gallery-collection__prev gallery-btn over-desktop-only"
            :class="{ 'active': galleryActive }" v-if="images.length > 1" @click.prevent="prevPhoto">
            <img src="/img/icons/gallery-arrow.svg" alt="arrow left" />
        </a>

        <div class="compact-gallery-collection__overlay-info" v-if="overlayType === 'info' && images.length > 1">
            <template v-if="showFloorplans">
                <svg viewBox="0 0 16 16" width="16" height="16">
                    <use xlink:href="#svg-icn-epc-icon"></use>
                </svg>
                <span style="margin-bottom: 3px;">|</span>
            </template>
            <i class="ri-image-line"></i>
            {{ currentPhotoIndex }}/{{ images.length }}
        </div>

        <div class="compact-gallery-collection__overlay-buttons d-flex justify-content-end px-3 gap-2 w-100"
            v-if="overlayType === 'buttons'">
            <a class="btn btn--sm btn--white-empty" href="#" @click.prevent="$emit('image-clicked', currentPhotoIndex)">
                <CameraIcon style="width: 25px;" />
                {{ currentPhotoIndex }}/{{ images.length }}
            </a>
            <a v-if="showFloorplans" class="btn btn--sm btn--white-empty" href="#"
                @click.prevent="$emit('show-floorplans-gallery')">
                <svg viewBox="0 0 16 16" width="16" height="16">
                    <use xlink:href="#svg-icn-epc-icon"></use>
                </svg>
                Floor plans
            </a>
            <a v-if="showMapBtn" class="btn btn--sm btn--white-empty" href="#map-location">
                <MapPinIcon />
                Map
            </a>
        </div>

        <!-- Extras -->
        <slot name="extras">
        </slot>
    </div>
</template>

<script>
import _ from 'lodash';

const CameraIcon = () => import('@components/partials/icons/CameraIcon.vue');
const MapPinIcon = () => import('@components/partials/icons/MapPinIcon.vue');

export default {
    components: {
        MapPinIcon,
        CameraIcon,
    },
    props: {
        images: {
            type: Array,
            required: true,
        },
        overlayType: {
            type: String,
            default: 'info',
            validator(value) {
                return ['info', 'buttons'].includes(value);
            },
        },
        showFloorplans: {
            type: Boolean,
            default: false,
        },
        showMapBtn: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentPhotoIndex: 1,
            galleryActive: false,
        };
    },
    methods: {
        nextPhoto() {
            this.galleryActive = true;
            if (this.currentPhotoIndex === this.images.length - 1) {
                this.$refs.gallery.scrollTo({
                    left: 0,
                    behavior: 'instant',
                });
            } else {
                this.$refs.gallery.scrollBy({
                    left: 500,
                    behavior: 'smooth',
                });
            }
        },
        prevPhoto() {
            this.galleryActive = true;
            if (this.currentPhotoIndex === 1) {
                this.$refs.gallery.scrollTo({
                    left: this.$refs.gallery.clientWidth * (this.images.length - 1),
                    behavior: 'instant',
                });
            } else {
                this.$refs.gallery.scrollBy({
                    left: -500,
                    behavior: 'smooth',
                });
            }
        },
        updateGalleryState: _.throttle(function () {
            this.currentPhotoIndex = Math.round(this.$refs.gallery.scrollLeft / (this.$refs.gallery.clientWidth / 2)) + 1;
        }, 300),
        imageUrl(image) {
            if (image.urls && image.urls.medium) return image.urls.medium;
            if (image.url) return image.url;
            return image;
        },
    },
};
</script>
